import React, { FunctionComponent, useEffect, useState } from 'react';
import moment from 'moment';
import Loader from '../../../../components/Loader';
import FormDisplay from '../../../../components/FormDisplay';
import { Form, Appointment } from '../../../../store/modules/application/types';
import { stripNulls } from 'src/utils/utils';

type AppointmentDataProps = {
    editForm: Form;
    appointmentDetail: Appointment;
    updateAppointment: Function;
    isLoading?: Boolean;
};

type AppointmentViewModel = Appointment & {
    date: string;
    startTime?: string;
    endTime?: string;
};

const AppointmentData: FunctionComponent<AppointmentDataProps> = (props) => {
    const { appointmentDetail, editForm, isLoading, updateAppointment } = props;

    const [viewModel, setViewModel] = useState<AppointmentViewModel>(() => {
        if (/^\d{4}-\d{2}-\d{2}$/.test(appointmentDetail.startDateTime)) {
            // This is a full-day event (there is no time data).
            return {
                ...appointmentDetail,
                date: appointmentDetail.startDateTime,
            };
        }

        const appointmentStart = moment(appointmentDetail.startDateTime);

        return {
            ...appointmentDetail,
            date: appointmentStart.format('YYYY-MM-DD'),
            startTime: appointmentStart.format('HH:mm'),
            endTime: appointmentDetail.endDateTime ? moment(appointmentDetail.endDateTime).format('HH:mm') : undefined,
        };
    });

    useEffect(() => {
        const appointmentStart = moment(appointmentDetail.startDateTime);

        setViewModel({
            ...appointmentDetail,
            date: appointmentStart.format('YYYY-MM-DD'),
            startTime: appointmentStart.format('HH:mm'),
            endTime: appointmentDetail.endDateTime ? moment(appointmentDetail.endDateTime).format('HH:mm') : undefined,
        });
    }, [appointmentDetail]);

    const handleSave = (value: AppointmentViewModel) => {
        const { date, startTime, endTime, ...updatedAppointment } = value;

        if (startTime) {
            updatedAppointment.startDateTime = moment(`${date}T${startTime}`).toISOString();
        } else {
            updatedAppointment.startDateTime = date;
        }

        if (endTime) {
            updatedAppointment.endDateTime = moment(`${date}T${endTime}`).toISOString();
        } else {
            // Setting to null to remove the existing value in the api call (undefined
            // is not marshalled into json).
            updatedAppointment.endDateTime = (null as unknown) as string | undefined;
        }
        if (!updatedAppointment.inspectionType?.id) {
            updatedAppointment.inspectionType = undefined;
        }
        stripNulls(updatedAppointment);
        updateAppointment(updatedAppointment, appointmentDetail.id);
    };
    if (isLoading) return <Loader />;

    return <FormDisplay form={editForm} record={viewModel} handleSave={handleSave} />;
};

export default AppointmentData;
